type MimeTypeMapping = Record<string, string>;

export const mimeTypeMapping: MimeTypeMapping = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  heic: "image/heic",
  tiff: "image/tiff",
  gif: "image/gif",
  bmp: "image/bmp",
  pdf: "application/pdf",
  msg: "application/vnd.ms-outlook",
};
